import { isSameDay } from "date-fns";

export const isValidDate = (date: Date): boolean => {
    return !isNaN(date.getTime());
};

export const isEndDateValid = (endDate: Date, startDate: Date): boolean => {
    return +endDate >= +startDate || isSameDay(endDate, startDate);
};